

































import Vue from 'vue';
import mixin from 'vue-typed-mixins';
import { toastMixin } from '@/Shared/CommonEntityMixins/ToastMixin';
import ValidationErrorDirective, { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { Dictionary } from 'vue-router/types/router';
import VatsAPI from '@/Shared/VatsAPI';
import I18nMixin from '@/Shared/I18nMixin';
import {Logger} from '@/Shared/Logger';

const PasswordResetCompletion = mixin(toastMixin, I18nMixin).extend({
    props: {
        requestId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            requestValid: null as boolean | null,
            validationErrors: {} as Dictionary<string[]>,
            newPassword: '',
            confirmedNewPassword: '',
            requestFailed: false
        };
    },
    directives: {
        ValidationErrorDirective
    },
    computed: {
        i18nPrefix(): string {
            return 'passwordResetCompletion';
        },
        passwordsMatch(): boolean {
            return this.newPassword === this.confirmedNewPassword;
        }
    },
    methods: {
        async submit() {
            this.validationErrors = {};
            try {
                const result = await VatsAPI.post(
                    `/Account/ResetPassword`,
                    { requestID: this.requestId, newPassword: this.newPassword }
                );

                const success = result.data;

                if (success) {
                    this.popupToast('requestSuccessTitle', 'requestSuccessMessage', this.i18nPrefix);

                    const redirectTimeSeconds = 2;
                    setTimeout(() => {
                        this.$router.push({ name: 'vatsLogin' });
                    }, redirectTimeSeconds * 1000);
                }
                else {
                    this.requestFailed = true;
                }
            }
            catch (e) {
              if (!e.response || e.response.status !== 400 || !e.response.data) {
                  this.popupToast('requestFailedTitle', 'requestFailedMessage', this.i18nPrefix);
                  return;
              }

              this.validationErrors = getValidationErrors(e.response);

              const hasPasswordErrors = this.validationErrors.hasOwnProperty('Password');

              if (hasPasswordErrors) {
                    const passwordErrors = this.validationErrors[`Password`];

                    const message: string = passwordErrors[0];

                    Logger.Log(message);

                    const title = this.$i18n.t('passwordResetCompletion.requestFailedTitle').toString();

                    Logger.Log(title);

                    this.$bvToast.toast(message, {title, autoHideDelay: 5000});
                }
            }
        },
    },
});

export default PasswordResetCompletion;
